<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="coupon_page.list_title" />

    <CouponList
      :coupons="filteredCoupons"
      :stats="stats"
      :loading="loading"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteCoupon"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateCouponModal
      :open="showModal"
      :is-edit="!!selectedCoupon"
      :form="form"
      :errors="errors"
      :loading="loading"
      @close="closeModal"
      @save="saveCoupon"
      @generate-code="generateCouponCode"
      @update-field="updateField"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CouponList from "../../components/Settings/CouponList.vue";
import CreateCouponModal from "../../components/Settings/CreateCouponModal.vue";
import { useCoupon } from "../../composables/useCoupon";

const {
  searchQuery,
  filteredCoupons,
  stats,
  showModal,
  selectedCoupon,
  form,
  errors,
  loading,
  paginationConfig,
  fetchCoupons,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  generateCouponCode,
  saveCoupon,
  deleteCoupon,
} = useCoupon();

onMounted(fetchCoupons);
</script>
